import PropTypes from 'prop-types'
import { createContext, useContext, useState, useMemo, useEffect } from 'react'

// Constants
import { DEFAULT, LIGHT_THEME_TYPES, LOADING_THEME } from 'src/constants/theme'

const ThemeContext = createContext()

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState()

  const isLightThemeType = useMemo(
    () => LIGHT_THEME_TYPES.includes(theme),
    [theme]
  )

  useEffect(() => {
    if (theme) {
      if (isLightThemeType) {
        document.body.style.backgroundImage =
          'radial-gradient(88.02% 32.04% at 50% 7.61%, #FFFFFF 0%, #E9E9EC 100%)'
        localStorage.setItem(LOADING_THEME, theme)
      } else {
        document.body.style.background =
          'radial-gradient(78.02% 20% at 50% 0%, hsl(287deg 20% 10%) 0%, hsl(197deg 6% 5%) 100%)'
        localStorage.setItem(LOADING_THEME, DEFAULT)
      }
    }
  }, [theme, isLightThemeType])

  const value = useMemo(
    () => ({
      theme,
      setTheme,
      isLightThemeType,
    }),
    [theme, setTheme, isLightThemeType]
  )

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

ThemeProvider.propTypes = {
  children: PropTypes.any.isRequired,
}

const useThemeContext = () => {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error('useThemeContext must be used within an ThemeProvider')
  }

  return { ...context }
}

export { ThemeProvider, useThemeContext }
